import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class EmployeeGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  async canActivate(): Promise<boolean> {
    await this.auth.ensureReady();
    await firstValueFrom(this.auth.loading$.pipe(filter(l => !l)));

    if (!this.auth.currentUser) {
      this.router.navigate(['/login']);
      return false;
    }

    if (!this.auth.isEmployee && !this.auth.isAdmin) {
      this.router.navigate(['/']);
      return false;
    }

    return true;
  }
}
